import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from './ThemeContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FloatingActions from './components/FloatingActions';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Solutions from './pages/Solutions';
import Clients from './pages/Clients';
import Contact from './pages/Contact';
import ScrollToTop from './components/ScrollToTop';
import LoadingScreen from './components/LoadingScreen';
import CursorGlow from './components/CursorGlow';
import './App.css';
import Careers from './pages/Careers';
import Terms from './pages/Terms';
import PrivacyPolicy from './pages/PrivacyPolicy';

function PageWrapper({ children }) {
  const location = useLocation();
  return (
    <div key={location.pathname} className="page-enter">
      {children}
    </div>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 2200);
    return () => clearTimeout(t);
  }, []);

  if (loading) return <LoadingScreen />;

  return (
    <HelmetProvider>
      <ThemeProvider>
        <Router>
          <ScrollToTop />
          <CursorGlow />
          <div className="app-wrapper">
            <Navbar />
            <main>
              <PageWrapper>
                <Routes>
                  <Route path="/"          element={<Home />} />
                  <Route path="/about"     element={<About />} />
                  <Route path="/products"  element={<Products />} />
                  <Route path="/solutions" element={<Solutions />} />
                  <Route path="/clients"   element={<Clients />} />
                  <Route path="/contact"   element={<Contact />} />
                  <Route path="/careers"   element={<Careers />} />
                  <Route path="/terms"   element={<Terms />} />
                  <Route path="/privacy-policy"   element={<PrivacyPolicy />} />
                </Routes>
              </PageWrapper>
            </main>
            <Footer />
            <FloatingActions />
          </div>
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: 'var(--bg-raised)',
                color: 'var(--text-primary)',
                border: '1px solid rgba(192,57,43,0.25)',
                borderRadius: '10px',
                fontFamily: 'Inter, sans-serif',
              },
              success: { iconTheme: { primary: '#C0392B', secondary: '#fff' } },
              error:   { iconTheme: { primary: '#E74C3C', secondary: '#fff' } },
            }}
          />
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
